export default __webpack_public_path__ + "static/proxima-nova-700-i-0f9f980d353cc5826a9dd1cab65dd364.woff";